interface Temporal {
  count: number;
  oldestAge: number;
}

export default class TemporalCountService {
  public constructor(
    private readonly url: string,
    private readonly frontId: string,
    private readonly key: string,
    private readonly timeToCount: number,
    private readonly tolerance: number,
  ) {}

  public async openTransaction(): Promise<void> {
    try {
      await this.setTemporalCount(this.key);
    } catch (error) {
      console.error('Not possible to set temporal count: ', error);
    }
  }

  public async isTemporalValid(score: number): Promise<boolean> {
    if (!this.key || !this.frontId) {
      this.logErrorTemporalCount(this.key, score);
      return false;
    }

    try {
      const response = await this.getTemporalCount(this.key);
      if (response.oldestAge < 1) {
        // to short to be valid
        this.logBlockTemporalCount(this.key, score);
        return false;
      }
      if (response.count >= this.tolerance) {
        // to many accesses to be valid
        this.logBlockTemporalCount(this.key, score);
        return false;
      }
      this.logPassTemporalCount(this.key, score);
      return true;
    } catch (error) {
      console.error('Not possible to get temporal count: ', error);
      this.logErrorTemporalCount(this.key, score);
      return false;
    }
  }

  private async getTemporalCount(key: string): Promise<Temporal> {
    const response = await fetch(`${this.url}get?id=${this.frontId}&key=${key}&sec=${this.timeToCount}`);
    return await response.json();
  }

  private async setTemporalCount(key: string) {
    return fetch(`${this.url}set?id=${this.frontId}&key=${key}`);
  }

  private async logBlockTemporalCount(key: string, score: number) {
    return fetch(`${this.url}block?id=${this.frontId}&key=${key}&score=${score}`);
  }

  private async logErrorTemporalCount(key: string, score: number) {
    return fetch(`${this.url}error?id=${this.frontId}&key=${key}&score=${score}`);
  }

  private async logPassTemporalCount(key: string, score: number) {
    return fetch(`${this.url}pass?id=${this.frontId}&key=${key}&score=${score}`);
  }

  private get xxxxkey(): string {
    // a chave é a url da página mas substituindo a query string "rating={valor}" por rating=X para computar as alterações de várias notas parciais
    // o url é codificado para evitar problemas com caracteres especiais pois pega da url do navegador. e a url do navegador pode ter caracteres especiais como &
    // e isso atrapalha na hora de passar isso como parâmetro na url do serviço

    // se a url for do tipo token/transacao/tentativa, então retorna isso.
    let match = window.location.href.match(/https?:\/\/[\w\.]+\/(\w+\/\d+\/\d+)/);
    if (match && match[1]) return match[1];

    return encodeURIComponent(window.location.href.replace(/rating=\d+/, 'rating=X'));
  }
}
